import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from '../finance/shared';

const BudgetCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [income, setIncome] = useState('5.000,00');
  const [expensesTotal, setExpensesTotal] = useState('3.500,00');
  const [res, setRes] = useState<any>(null);

  const calculate = () => {
    const inc = parseFloat(parseBrazilianNumber(income)) || 0;
    const exp = parseFloat(parseBrazilianNumber(expensesTotal)) || 0;
    const balance = inc - exp;
    const savingsRate = inc > 0 ? (balance / inc) * 100 : 0;

    setRes({ balance, savingsRate });
    onResultChange([
      { label: 'Renda', value: `R$ ${inc.toLocaleString('pt-BR')}` },
      { label: 'Despesas', value: `R$ ${exp.toLocaleString('pt-BR')}` },
      { label: 'Saldo', value: `R$ ${balance.toLocaleString('pt-BR')}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <FormField label="Renda Mensal" value={income} onChange={setIncome} isNumeric required type="text" />
          <FormField label="Despesas Totais" value={expensesTotal} onChange={setExpensesTotal} isNumeric required type="text" />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:scale-105 transition-all">Analisar</button>
        </div>
        {res && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ResultCard title="Saldo Mensal" value={`R$ ${res.balance.toLocaleString('pt-BR')}`} color={res.balance >= 0 ? 'emerald' : 'rose'} />
            <ResultCard title="Taxa de Poupança" value={`${res.savingsRate.toFixed(1)}%`} color="indigo" />
          </div>
        )}
      </div>
    </div>
  );
};

export default BudgetCalculator;
